var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 3,
    fill: "black",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.0512L6.83073 6.7002H8.28239L11.1222 13.0512H9.57981L7.25716 7.44417H7.83782L5.5061 13.0512H4ZM5.41537 11.6903L5.8055 10.5743H9.07173L9.47094 11.6903H5.41537Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6754 13.0512V12.0986L14.5846 11.8899V10.1842C14.5846 9.88175 14.4909 9.64585 14.3034 9.47649C14.1219 9.30713 13.8407 9.22245 13.4596 9.22245C13.1995 9.22245 12.9424 9.26479 12.6884 9.34947C12.4404 9.4281 12.2287 9.53698 12.0533 9.6761L11.5452 8.68715C11.8114 8.49965 12.1319 8.35448 12.5069 8.25166C12.882 8.14883 13.263 8.09742 13.6501 8.09742C14.3941 8.09742 14.9717 8.27283 15.383 8.62364C15.7943 8.97446 16 9.52186 16 10.2658V13.0512H14.6754ZM13.1874 13.1238C12.8064 13.1238 12.4797 13.0603 12.2075 12.9333C11.9354 12.8002 11.7267 12.6218 11.5815 12.398C11.4363 12.1742 11.3638 11.9231 11.3638 11.6449C11.3638 11.3546 11.4333 11.1005 11.5724 10.8828C11.7176 10.665 11.9444 10.4957 12.2529 10.3747C12.5614 10.2477 12.9636 10.1842 13.4596 10.1842H14.757V11.0098H13.6138C13.2812 11.0098 13.0513 11.0642 12.9243 11.1731C12.8033 11.282 12.7428 11.4181 12.7428 11.5814C12.7428 11.7629 12.8124 11.908 12.9515 12.0169C13.0967 12.1197 13.2933 12.1711 13.5413 12.1711C13.7771 12.1711 13.9888 12.1167 14.1764 12.0078C14.3639 11.8929 14.5 11.7266 14.5846 11.5088L14.8024 12.1621C14.6996 12.4766 14.512 12.7155 14.2399 12.8788C13.9677 13.0421 13.6169 13.1238 13.1874 13.1238Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextIcon);
export default __webpack_public_path__ + "static/media/text_icon.8f4b0e263af93e3ecebf35ec9f3e74c9.svg";
export { ForwardRef as ReactComponent };